import { CalendarBlank, CheckCircle, Clock, Heart, SignOut } from "@phosphor-icons/react";
import { Badge } from "@/components/ui/badge";

export { ATTENDANCE_STATUS_ORDER } from "@/lib/attendanceRecap";

export const ATTENDANCE_STATUSES = {
  hadir: {
    label: "Hadir",
    icon: CheckCircle,
    className: "border-[hsl(var(--success))]/60 bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]",
  },
  sakit: {
    label: "Sakit",
    icon: Heart,
    className: "border-violet-600/40 bg-violet-600/10 text-violet-700 dark:border-violet-400/40 dark:bg-violet-400/10 dark:text-violet-300",
  },
  cuti: {
    label: "Cuti",
    icon: CalendarBlank,
    className: "border-primary/40 bg-primary/10 text-primary",
  },
  terlambat: {
    label: "Terlambat",
    icon: Clock,
    className: "border-[hsl(var(--warning))]/60 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]",
  },
  pulang_cepat: {
    label: "Pulang Cepat",
    icon: SignOut,
    className: "border-orange-700/40 bg-orange-700/10 text-orange-800 dark:border-orange-400/40 dark:bg-orange-400/10 dark:text-orange-300",
  },
  izin: {
    label: "Izin",
    icon: CalendarBlank,
    className: "border-muted-foreground/30 bg-muted text-muted-foreground",
  },
};

export function AttendanceStatusPill({ status, className = "" }) {
  const config = ATTENDANCE_STATUSES[status] || {
    label: status ? String(status).replaceAll("_", " ") : "Belum ada status",
    icon: Clock,
    className: "border-muted-foreground/30 bg-muted text-muted-foreground",
  };
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={`inline-flex items-center gap-1.5 whitespace-nowrap font-medium ${config.className} ${className}`}>
      <Icon size={14} weight="bold" aria-hidden="true" />
      {config.label}
    </Badge>
  );
}
